import { useTranslation } from "react-i18next"
import { Colors } from "../../constants/colors"
import { ShiftType } from "../../redux/types"
import Badge from "../Badge"

interface Props {
    shiftType: ShiftType
}

const ShiftTypeBadge = ({shiftType}: Props) => {
    const {t} = useTranslation(['shifts']);

    const badgeColor = () => {
      switch (shiftType) {
        case 'standard':
          return Colors.euro_800
        case 'custom':
          return Colors.yen_600
      }
    }

    const badgeTextColor = () => {
      switch (shiftType) {
        case 'standard':
          return Colors.gray4
        case 'custom':
          return Colors.gray0
      }
    }

    return (
      <Badge
        text={t(`type_${shiftType}`, {ns: 'shifts'})}
        backgroundColor={badgeColor()}
        textColor={badgeTextColor()}
      />
    )
}

export default ShiftTypeBadge